<template>
    <div class="h-full w-full flex flex-col">
        <PipelinePartnerForm mode="edit" :entities="entities" :selected-item="selectedItem" @updated="onUpdated" @close="$emit('close')" />
    </div>
</template>

<script>
import PipelinePartnerForm from "./form.vue";
export default {
    name: "pipeline-partners-edit",
    emits: ["updated", "close"],
    props: ["entities", "selectedItem"],
    components: { PipelinePartnerForm, },
    methods: {
        onUpdated(msg) {
            this.$emit('updated', msg);
        }
    },
}
</script>